import crypto from 'crypto'
import jsrsasign from 'jsrsasign'

let rsa_public_key =
  'b3764d7f25497d340ae81953af7a898e1c1ea320489b17868906c537b33b6446f24ce902227db22540bfd80da256b4fc53b385ea7a4233a4e1e02d0be19aac8fac1e23830de13968bb089f767533716c03032172f8e32e2f105e22ff12ecc0f0ffae68b70f70fa6994dafd56e011178b339791b762413a29d1960b4fbe133c50bc8c3bf11bd985309440d1b9e3770dcc291f91e5388fe95dee06b2de9ca0ad35c0b89ba9e2ac282276bb09f477f3d0ffc5384f245b900b4d17eb3d16129d0666f02668459ea987531ab8b00c184ffd198d74114ccf34691ba63152812c3f4bbd415fef1770f9b4a4a178ae89eed96fd99c73ff750356a5905ae268a8cdff0657'
let rsa_public_exponent = '10001'

// rsa加密
// 不可加密数字，否则解密为空
function rsa(text) {
  let pub = jsrsasign.KEYUTIL.getKey({ n: rsa_public_key, e: rsa_public_exponent })
  let enc = jsrsasign.KJUR.crypto.Cipher.encrypt(text, pub)
  return `rsa.${enc}`
}
// md5加密
function md5(str) {
  let md5 = crypto.createHash('md5')
  md5.update(str)
  let md5Result = md5.digest('hex')
  return md5Result
}

const CryptoJS = require('crypto-js')
const base32 = require('base32.js')

function byteArrayToBase64(byteArray) {
  return btoa(String.fromCharCode.apply(null, byteArray))
}

function base64ToString(base64) {
  return atob(base64)
}
const secretKey = 'da4756119d5e7e0f'
function decryptAES_new(encryptedData) {
  // 将密钥解析为字节数组
  const key = CryptoJS.enc.Utf8.parse(secretKey)

  // 使用 base32.js 解码 Base32 编码的数据
  const decodedBytes = base32.decode(encryptedData)
  // 转换成字符串
  const base64String = byteArrayToBase64(decodedBytes)
  const decodedBytesString = base64ToString(base64String)

  // 使用AES解密 (ECB 模式，不需要 IV)
  const bytes = CryptoJS.AES.decrypt(decodedBytesString, key, {
    mode: CryptoJS.mode.ECB, // 修改为 ECB 模式
    padding: CryptoJS.pad.Pkcs7, // 使用 PKCS#7 填充
  })

  // 将解密后的字节数据转换为UTF-8字符串
  return bytes.toString(CryptoJS.enc.Utf8)
}

function encryptAES_new(data) {
  // 将密钥解析为字节数组
  const key = CryptoJS.enc.Utf8.parse(secretKey)
  // 将数据转换为字节数组
  const plainTextBytes = CryptoJS.enc.Utf8.parse(data)
  // 使用AES加密 (ECB 模式，不需要 IV)
  const encrypted = CryptoJS.AES.encrypt(plainTextBytes, key, {
    mode: CryptoJS.mode.ECB, // ECB 模式
    padding: CryptoJS.pad.Pkcs7, // 使用 PKCS#7 填充
  })
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64)
}

// 解密函数
function decryptAES(encryptedData) {
  // 将密钥解析为字节数组
  const key = CryptoJS.enc.Utf8.parse(secretKey)
  // const ivBytes = CryptoJS.enc.Utf8.parse(iv);

  // 将十六进制的加密数据解析为字节数组，然后转换为Base64格式
  const encryptedBytes = CryptoJS.enc.Hex.parse(encryptedData)
  const encryptedBase64 = CryptoJS.enc.Base64.stringify(encryptedBytes) // 转为Base64格式

  // 使用AES解密 (ECB 模式，不需要 IV)
  const bytes = CryptoJS.AES.decrypt(encryptedBase64, key, {
    // iv: ivBytes,
    mode: CryptoJS.mode.ECB, // 修改为 ECB 模式
    padding: CryptoJS.pad.Pkcs7, // 使用 PKCS#7 填充
  })

  // 将解密后的字节数据转换为UTF-8字符串
  return bytes.toString(CryptoJS.enc.Utf8)
}

// 加密函数
function encryptAES(data) {
  // 将密钥解析为字节数组
  const key = CryptoJS.enc.Utf8.parse(secretKey)
  // 将数据转换为字节数组
  const plainTextBytes = CryptoJS.enc.Utf8.parse(data)
  // 使用AES加密 (ECB 模式，不需要 IV)
  const encrypted = CryptoJS.AES.encrypt(plainTextBytes, key, {
    mode: CryptoJS.mode.ECB, // ECB 模式
    padding: CryptoJS.pad.Pkcs7, // 使用 PKCS#7 填充
  })
  // 返回加密后的数据转换为十六进制字符串
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex)
}

// 公钥 pem格式
const publicKeyPem = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAotqWtn3vjBlVQqnpJRiM
9/P8FnA8iWoOBIklF4N5ZDeJi8ijWPT5dwNfHLBAB2LS3E5jL/WAWmdY8Dyruk7P
ao23ixlOXiz8TFT/FalHG/pIDNuXdnqWfhKIIgJXzbNwG6bub68Nv4yox5q9CVcn
HgstzV/NFUmLj5KSB1KS57x3wINLK/7cotkXkhrYGmfntq85VPT0LjbUPFPZzulp
wYyW3Lmlt2yKzc88QPZtoyaJbX3de3B5Yiut2C3xHJhS01PMGZsqjLPS3qiA+AVI
2qqAufCtc6qObD6A3ddRYT/RyyjXXrD5BbzRZWs3Z2wOR0dX1xBLJmH19ZQq/MHJ
ywIDAQAB
-----END PUBLIC KEY-----`
// RSA 使用pem格式公钥 加密
function encryptRSA(text) {
  if (text === null || text === undefined || text === '') return null
  try {
    // 获取公钥对象
    const rsa = jsrsasign.KEYUTIL.getKey(publicKeyPem)
    const encrypted = jsrsasign.KJUR.crypto.Cipher.encrypt(text, rsa, 'RSA')
    return encrypted
  } catch (error) {
    console.error('RSA Encryption failed:', error)
    return null
  }
}

export { rsa, md5, decryptAES_new, encryptAES_new, decryptAES, encryptAES, encryptRSA }
